<template functional>
  <div class="relative">
    <span
      class="red cursor-pointer p-0.5 rounded-md hover:bg-white"
      :data-action="'showPayable'"
      :data-order-id="props.item.id"
    >
      {{ props.item.charges.payable | toCurrency }}
    </span>
  </div>
</template>

<script>
export default {
  name: "drayage-ap",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
